export default __webpack_public_path__ + "styles/icons/solutions.svg";